import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  MdOutlineClose,
  MdOutlineCheck,
  MdOutlineRefresh,
  MdOutlineSearch,
  MdSearch,
} from "react-icons/md";
import { Input, Button } from "react-daisyui";
// import { useCityStore } from "../store/CityStore";
import { observer } from "mobx-react";
import { useCategoriesStore } from "../Store/CategoriesManagement";

const Filter = observer(() => {
  const {
    getbrandname,
    SetfilterSearch,
    getFilterBrand,
    getBrandList,
    allclear,
    brandname,
  } = useCategoriesStore();
  return (
    <>
      <div className="card bg-base-100 shadow-md p-6 mt-3 mb-10">
        <form
        //   onSubmit={(e) => {
        //     getFilterBrand();
        //     e.preventDefault();
        //   }}
          className=" flex flex-row justify-between mb-3  "

        >
          <div className="w-full">
            <div>
              <input
                name="Categorie"
                // onChange={(e) => SetfilterSearch(e.target.value)}
                placeholder="Search"
                id="Categorie"
                type="text"
                autoComplete="off"
                className="input focus:outline-0 w-full text-sm font-medium rounded-md capitalize focus:outline-offset-0 input-bordered"
              />
            </div>
          
          </div>
 
        </form>
        <div className="flex justify-end" >
            <button
              type="reset"
              onClick={() => {
                allclear();
                // getBrandList();
              }}
              className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
            >
              <MdOutlineRefresh className="mr-1" />
              Reset
            </button>
            <button className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
              <MdOutlineSearch className="mr-1" />
              Search
            </button>
          </div>
      </div>
    </>
  );
});
export default Filter;
